import { Component, Input, OnInit } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import ProjectHelper from 'src/app/helpers/project-helper';
import Board from 'src/app/model/product/board/board';
import { Project } from 'src/app/model/project/project';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionWithDestroyTriggerComponent } from 'src/app/subscription-helpers/subscription-with-destroy-trigger.component';

@Component({
  selector: 'board-price-summary',
  templateUrl: './board-price-summary.component.html',
  styleUrls: ['./board-price-summary.component.scss']
})
export class BoardPriceSummaryComponent
  extends SubscriptionWithDestroyTriggerComponent
  implements OnInit {
  @Input()
  board: Board;

  @Input()
  project: Project;

  atLeastOneRetailer: boolean = false;
  atLeastOneSignSize: boolean = false;
  atLeastOneNoSignSize: boolean = false;

  productionPrice: number = 0;
  placementPrice: number = 0;
  paintedPostsPrice: number = 0;
  subtotal: number = 0;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit(): void {
    this.atLeastOneRetailer = ProjectHelper.getAtLeastOneRetailer(
      this.project.projectContacts
    );
    this.calculatePrices();

    const calculateSubTotalObservable = this.createObservableUntilDestroy(
      this.projectDisplayObservableService.getProductPlacementVariableChangedSubscribable(),
      this.projectDisplayObservableService.getProductSizeChangedSubscribable()
    );

    this.addSubscription(calculateSubTotalObservable, () =>
      this.calculatePrices()
    );

    this.addSubscription(
      this.projectDisplayObservableService.getProjectContactsChangedSubscribable(),
      () => {
        this.atLeastOneRetailer = ProjectHelper.getAtLeastOneRetailer(
          this.project.projectContacts
        );
        this.calculatePrices();
      }
    );
  }

  private calculatePrices(): void {
    this.atLeastOneSignSize =
      CollectionHelper.isPopulated(this.board.boardParts) &&
      this.board.boardParts.some(bp => bp.signSize != null);

    if (!this.atLeastOneSignSize) {
      this.atLeastOneNoSignSize = false;
      this.zeroPrices();
    } else {
      this.atLeastOneNoSignSize = this.board.boardParts.some(
        bp => bp.signSize == null
      );
      this.combinePrices();
    }
  }

  private zeroPrices(): void {
    this.productionPrice = 0;
    this.placementPrice = 0;
    this.paintedPostsPrice = 0;
    this.subtotal = 0;
  }

  private combinePrices(): void {
    let productionPriceAccumulator = 0;
    let placementPriceAccumulator = 0;
    let paintedPostsPriceAccumulator = 0;

    this.board.boardParts.forEach(bp => {
      if (bp.signSize == null) {
        return;
      }
      const productionPriceString = ProductHelper.getBoardPartProductionRetailPriceIfApplicable(
        bp,
        this.atLeastOneRetailer
      );
      const productionPrice =
        productionPriceString == null ? 0 : Number(productionPriceString);
      const placementPriceString = ProductHelper.getBoardPartPlacementRetailPriceIfApplicable(
        bp,
        this.atLeastOneRetailer
      );
      const placementPrice =
        placementPriceString == null ? 0 : Number(placementPriceString);
      const paintedPostsPrice =
        bp.signSize.paintedPostsPrice == null || !bp.paintedPosts
          ? 0
          : Number(bp.signSize.paintedPostsPrice);
      productionPriceAccumulator += productionPrice;
      placementPriceAccumulator += placementPrice;
      paintedPostsPriceAccumulator += paintedPostsPrice;
    });

    this.productionPrice = productionPriceAccumulator;
    this.placementPrice = placementPriceAccumulator;
    this.paintedPostsPrice = paintedPostsPriceAccumulator;
    this.subtotal =
      productionPriceAccumulator +
      placementPriceAccumulator +
      paintedPostsPriceAccumulator;
  }
}
